module.exports = __webpack_public_path__ + "img/cartaz-mobile.830ca4db.jpg";